

















































































































































import { FromStore } from "@abaco/web-common/src/app";
import { ToastOptions } from "@abaco/web-common/src/app/Toasted";
import { EmptyPagedResults, infiniteLoad, PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { TranslateResult } from "vue-i18n";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../index";
import { ContractItem } from "../models/Contract";
import { Subject } from "../models/Subject";

@Component
export default class ContractsList extends Vue {
    @Inject() toast!: (message: string, options?: ToastOptions) => void;
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @FromStore(MODULE_ID) isSignleSubject!: boolean;
    @FromStore(MODULE_ID) currentSubject!: Subject;
    @Prop() subjectId!: string;
    
    loading = true;
    identifier = 1;
    page: PagedResults<ContractItem> = new EmptyPagedResults();
        
    async loadData() {
        this.loading = true;
        const isSignleSubject = await this.maltaModule.maltaApi.getSubjects();
        this.isSignleSubject = isSignleSubject.isSingle();
        if (!this.currentSubject) {
            const [subj, err] = await this.maltaModule.maltaApi.getSubject(this.subjectId);
            if (err) {
                this.toast(this.i18n("subject-not-found").toString(), { type: "error" });
                this.$router.push({ name: "subjectList", replace: true });
                this.loading = false;
                return;
            } else if (subj) {
                this.currentSubject = subj;
            }
        }
        this.loading = false;
    }

    async loadNextPage(): Promise<boolean> {
        const newPage = await infiniteLoad(
            (paging: PagingParams) => this.maltaModule.maltaApi.getContracts(paging, this.subjectId),
            this.page
        );
        if (newPage) {
            this.page = newPage;
            return true;
        }
        return false;
    }

    newApplication(contract: ContractItem) {
        if (contract.can_progress) {
            this.$router.push({
                name: "ppr-home",
                params: {
                    subjectId: this.subjectId,
                    contractId: contract.subject_id.toString(),
                    applicationId: Math.abs(contract.can_progress).toString()
                }
            });
        } else {
            this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
        }
    }

    projectCompletionReport(contract: ContractItem) {
        if (contract.contract_id) {
            if (contract.can_complete) {
                this.$router.push({
                    name: "pcr-home",
                    params: {
                        subjectId: this.subjectId,
                        contractId: contract.contract_id.toString(),
                        applicationId: Math.abs(contract.can_complete).toString()
                    }
                });
            } else {
                this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
            }
        }
    }

    selectProgressReport(contract: ContractItem) {
        if (contract.contract_id) {
            if (contract.can_progress) {
                this.$router.push({
                    name: "ppr-home",
                    params: {
                        subjectId: this.subjectId,
                        contractId: contract.contract_id.toString(),
                        applicationId: Math.abs(contract.can_progress).toString()
                    }
                });
            } else {
                this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
            }
        }
    }

    projectChangeRequests(contract: ContractItem) {
        if (contract.contract_id && Math.abs(contract.contract_id)) {
            const applicationId = contract.application_id !== null ? contract.application_id.toString() : "0";
            const params = {
                subjectId: this.subjectId,
                contractId: Math.abs(contract.contract_id).toString(),
                applicationId
            };

            if (contract.canChange) {
                if (typeof contract.application_id === "number") {
                    this.$router.push({
                        name: "change-requests-home",
                        params
                    });
                } else {
                    this.$router.push({
                        name: "change-requests-agreement",
                        params,
                        replace: true
                    });
                }
            }
        }
    }

    selectProgressProposal(contract: ContractItem) {
        if (contract.application_id) {
            if (contract.can_proposal)
                this.$router.push({
                    name: "project-proposal-home",
                    params: {
                        subjectId: this.subjectId,
                        applicationId: contract.application_id.toString()
                    }
                });
            else this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
        }
    }

    addApplication() {
        console.warn("ADD APPLICATION");
    }

    //change request scripts
    
    // Route params
    get parentsubjectId(): string {
        return String(this.$route.params.subjectId || "");
    }
    get parentAppId(): number | null {
        const raw = this.$route.params.applicationId;
        const n = Number(raw);
        return Number.isFinite(n) ? n : null;
    }
    // data
    $refs!: { tncFooter?: HTMLElement };
    tncVisible = false;
    tncAccepted = false;
    tncHtml ="";
    creating = false;
    selectedContractForCR: ContractItem | null = null;
    // Validation
    //rules = [(v: boolean) => v || this.i18n("accept-terms-and-conditions").toString()];

    // open from row button
    openCRAgreement(item: ContractItem) {
        this.selectedContractForCR = item;
        this.tncHtml =
            (item.disclaimer && String(item.disclaimer).trim()); 
        this.tncAccepted = false;
        this.tncVisible = true;

        this.$nextTick(() => {
            this.$refs?.tncFooter?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }

    async proceedCreateCR() {
    const subjectId = String(this.parentsubjectId ?? '').trim();
    const parentAppIdNum = this.selectedContractForCR?.application_id;

    if (!subjectId || parentAppIdNum == null || Number.isNaN(parentAppIdNum)) {
        this.toast(this.i18n('Missing subjectId or parentAppId').toString(), { type: 'error' });
        return;
    }

    const [resp, err] = await this.maltaModule.projectProposalApi.createChangeRequestNew(
        subjectId,
        String(parentAppIdNum)
    );

    if (err) {
        if (err.response && err.response.status === 500 && err.response?.data?.i18n) {
        this.toast(this.i18n(err.response.data.i18n).toString(), { type: 'error', duration: 7000 });
        } else {
        this.toast(this.i18n('something-went-wrong').toString(), { type: 'error' });
        }
        return;
    }

    if (resp?.application_id) {
        // use query (route expects query)
        this.$emit('reload', true, resp.application_id);
        this.$router.replace({
        name: "project-proposal-home",
        params: {
            subjectId,
            applicationId: String(resp.application_id),
        },
        });

        return;
    }

    this.toast(this.i18n('something-went-wrong').toString(), { type: 'error' });
    }


    cancelTnc() { this.tncVisible = false; this.selectedContractForCR = null; this.tncAccepted = false; }

    get canShowStartBtn(): boolean {
        return this.tncAccepted ;
    }

    grouped(list: ContractItem[]): ContractItem[] {
    const items = list ?? [];
    const parents: ContractItem[] = [];
    const childrenByParent = new Map<number, ContractItem[]>();

    for (const r of items) {
        const isCR = r.is_change_request === '1';
        const parentId = r.original_application_id;

        if (isCR && parentId != null) {
        const pid = Number(parentId);
        let bucket = childrenByParent.get(pid);
        if (!bucket) {
            bucket = [];
            childrenByParent.set(pid, bucket);
        }
        bucket.push(r);
        } else {
        parents.push(r);
        }
    }

    const out: ContractItem[] = [];
    // keep original parent order
    for (const p of parents) {
        out.push(p);
        const kids = childrenByParent.get(Number(p.application_id));
        if (kids && kids.length) out.push(...kids);
    }

    // append orphan CRs (if parent not in current page)
    for (const [pid, kids] of childrenByParent.entries()) {
        if (!parents.some(p => Number(p.application_id) === pid)) {
        out.push(...kids);
        }
    }

    return out;
    }

    hasExistingCRFor(item: ContractItem, all: ContractItem[]): boolean {
    const appId = item.application_id;
    if (typeof appId !== 'number') return false;

    const isInProgress = (r: ContractItem) =>
        String(r.application_status_description || '').trim().toUpperCase() === 'IN PROGRESS' ||
        String(r.application_status_code || '').trim() === '000001'; // fallback by code

    // A parent has an existing CR only if a child CR (original_application_id = parent appId)
    // is currently IN PROGRESS.
    return all.some(r =>
        Number(r.original_application_id) === appId && isInProgress(r)
    );
    }


    //change request end here
    
    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    async mounted() {
        await this.loadData();
    }

    

    
}
